import React, { Fragment } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, Label, Form, FormGroup } from "reactstrap";
import { Card, CardBody } from "reactstrap";
import { EAITitle } from "../../../../../../constant";
import formatedDate from "../../../../../../utilities/formatedDate";
// import 'bootstrap/dist/css/bootstrap.min.css';


const ViewCommunicationDetailMessageModal = (props) => {

    const { communicationData } = props;
    
    return (
        <Fragment>
            <Modal isOpen={props.isOpen} toggle={props.toggle} size={communicationData?.type === 'EMAIL' ? 'lg' : ''}>
                <ModalHeader toggle={props.toggle} className="border-0">{"Communication Details"}</ModalHeader>
                <ModalBody>
                    <Form className="needs-validation" noValidate>
                        <Row>
                            <Col xl="6" md="6">
                                <FormGroup>
                                    <Label>{"Sent Date:"}</Label>
                                </FormGroup>
                            </Col>
                            <Col xl="6" md="6" className='text-right'>
                                <FormGroup>
                                    <Label>{communicationData?.createdDate}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl="6" md="6">
                                <FormGroup>
                                    <Label>{"Type:"}</Label>
                                </FormGroup>
                            </Col>
                            <Col xl="6" md="6" className='text-right'>
                                <FormGroup>
                                    <Label>{communicationData?.type}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl="6" md="6">
                                <FormGroup>
                                    <Label>{"Status:"}</Label>
                                </FormGroup>
                            </Col>
                            <Col xl="6" md="6" className='text-right'>
                                <FormGroup>
                                    <Label>
                                    {communicationData?.status}
                                        {/* <span className={`badge badge-${communicationData?.toUpperCase() === "DELIVERED" ? "success" : communicationData?.toUpperCase() === "ERROR" ? "danger" : communicationData?.toUpperCase() === "PENDING" ? "warning" : ""}`}>
                                            {communicationData?.status ? communicationData?.status : 'NA'}
                                        </span> */}
                                        {/* {typeof communicationData === 'string' ? 
                                            <span className={`badge badge-${communicationData?.toUpperCase() === "DELIVERED" ? "success" : communicationData?.toUpperCase() === "ERROR" ? "danger" : communicationData?.toUpperCase() === "PENDING" ? "warning" : ""}`}>
                                                {communicationData?.status ? communicationData?.status : 'NA'}
                                            </span> 
                                            : null
                                        } */}
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        
                        <Row>
                            <Col xl="6" md="6">
                                <FormGroup>
                                    <Label>{"Delivered at:"}</Label>
                                </FormGroup>
                            </Col>
                            <Col xl="6" md="6" className='text-right'>
                                <FormGroup>
                                    <Label>{communicationData?.deliveredAtDate || '-'}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl="6" md="6">
                                <FormGroup>
                                    <Label>{"Mihpayid:"}</Label>
                                </FormGroup>
                            </Col>
                            <Col xl="6" md="6" className='text-right'>
                                <FormGroup>
                                    <Label>{communicationData?.mihpayid || '-'}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xl="6" md="6">
                                <FormGroup>
                                    <Label>{"Transaction ID for Refund:"}</Label>
                                </FormGroup>
                            </Col>
                            <Col xl="6" md="6" className='text-right'>
                                <FormGroup>
                                    <Label>{communicationData?.transactionIdForRefund || '-'}</Label>
                                </FormGroup>
                            </Col>
                        </Row>
                        {communicationData?.type === 'SMS' && (
                            <Row>
                                <Col xl="12" md="12" >
                                    <Label>Body:</Label>
                                    <div className="d-flex justify-content-center pt-2">
                                        <div>
                                            <h6 className="pl-2 text-muted"> {EAITitle}</h6>
                                            <Card className="content-body-background">
                                                <CardBody className="p-3">
                                                    <div className="">
                                                        <span>{communicationData?.body ? communicationData?.body : "NA"}</span>
                                                    </div>
                                                </CardBody>
                                            </Card>
                                        </div>

                                    </div>

                                </Col>
                            </Row>
                        )}

                        {communicationData?.type === 'EMAIL' && (
                            
                            <Row>
                                <Col xl="12" md="12" >
                                    <Label>Body</Label>
                                    <div className="d-flex justify-content-center pt-2">
                                        <div>
                                            <Card  className="content-body-background">
                                                <CardBody className="p-4 ">
                                                    {/* <div className="">
                                                        <span>{communicationData?.body ? communicationData?.body : "NA"}</span>
                                                    </div> */}

                                                    {/* <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: communicationData?.body ? communicationData?.body : "NA"
                                                        }}
                                                        /> */}

                                                            <div className="card"style={{width: '650px', height: '600px' }}>
                                                                <div className="card-body" dangerouslySetInnerHTML={{ __html: communicationData?.body ? communicationData?.body : "NA" }} />
                                                            </div>
                                                </CardBody>
                                            </Card>
                                        </div>

                                    </div>

                                </Col>
                            </Row>
                    
                        )}

                        {communicationData?.type === 'WHATSAPP' && (
                            <Row>
                                <Col xl="12" md="12" >
                                    <Label>Body</Label>
                                    <div className="d-flex justify-content-left pt-2">
                                        <div>
                                            <Card  className="content-body-background">
                                                <CardBody className="p-3 ">
                                                  
                                                 
                                                        <div className="card">
                                                            <div className="card-body" dangerouslySetInnerHTML={{ __html: communicationData?.body ? communicationData?.body : "NA" }} />
                                                        </div>
                                                 
                                                </CardBody>
                                            </Card>
                                        </div>

                                    </div>

                                </Col>
                            </Row>
                        )}
                        
                    </Form>
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default ViewCommunicationDetailMessageModal;
